
import {userApi} from './user'

export const deleteAccountApi = userApi.injectEndpoints({
  endpoints: (builder) => ({    
    DeleteAccount: builder.mutation({

   
      query: ({payload}) => ({
        url: `/delete`,
        method: 'POST',
        body: payload,
      }),
    }),

  }),
  overrideExisting: false,
})

export const { useDeleteAccountMutation } = deleteAccountApi

